import type {z} from 'zod';
import type {
  VerifyReCaptchaTokenRequestData,
  responseDataSchema,
} from '../entities/verifyReCaptcha/schema';

export const verifyReCaptchaToken = async ({
  token,
}: VerifyReCaptchaTokenRequestData) => {
  const response = await fetch('/api/recaptcha/verify', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      token,
    }),
  });

  return response.json() as Promise<z.infer<typeof responseDataSchema>>;
};
